<template>
    <div>
        <!--The inputs are plotData, plotOptions and plotLines-->
        <div v-if="chartPlotted">
            <apexchart ref="chart" :options="plotOptions" :series="plotData"></apexchart>
            <!--div class="row d-flex justify-content-center">
                <label class="form-check-label col-auto" v-for="(line,index) in plotLines" :key="index" >
                    <input
                        type="checkbox"
                        v-model="checkboxValues[line.name]"
                        @change="toggleDataSeries(line.label,line.name, $event.target.checked)"
                        class="form-check-input">
                            {{ line.label }} {{ checkboxValues[line] }}
                </label>
            </div-->
        </div>
        <div class="row" v-else>
            <div class="col-12 mb-4">
                <div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
                    <div class="card-body text-center">
                        <b-spinner
                            variant="primary"
                            type="grow"
                            font-scale="7.5"
                            class="mb-2"
                        >
                        </b-spinner>
                        <h5 class="card-title" style="color:black">{{ $t("loading") }}</h5>
                        <p class="card-text" style="color:black">
                            {{ $t('chart-loading') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: 'Plotter',
    props: {
        plotData: Array,
        plotOptions: Object,
        plotLines: Array,
        chartPlotted: Boolean
    },
    methods: {
        toggleSeries(name) {
            if ('chart' in this.$refs) {
                this.$refs.chart.toggleSeries(name);
            }
        },
    },
}
</script>
